export { SuiRatingModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/rating/public.js
// module id = 1116
// module chunks = 0